(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  L.Control.MfPolygon = (function(superClass) {
    extend(MfPolygon, superClass);

    function MfPolygon() {
      this._polySelected = bind(this._polySelected, this);
      this._drawPolygon = bind(this._drawPolygon, this);
      this._drawCircle = bind(this._drawCircle, this);
      this._drawRectangle = bind(this._drawRectangle, this);
      this.select = bind(this.select, this);
      this.deselect = bind(this.deselect, this);
      this._additiveButtonPressed = bind(this._additiveButtonPressed, this);
      this._subtractiveButtonPressed = bind(this._subtractiveButtonPressed, this);
      this.handleMarkerDrop = bind(this.handleMarkerDrop, this);
      this.setAllToolOptions = bind(this.setAllToolOptions, this);
      this.setStealthStyling = bind(this.setStealthStyling, this);
      this.setDefaults = bind(this.setDefaults, this);
      this.setColor = bind(this.setColor, this);
      MfPolygon.__super__.constructor.call(this);
      this.setDefaults();
      this.noTooltipButtons = true;
      this.optionModeAll = false;
      L.drawLocal.draw.handlers.rectangle.tooltip.start = 'Click or drag to draw rectangle';
      L.drawLocal.draw.handlers.circle.tooltip.start = 'Click or drag to draw circle';
    }

    MfPolygon.prototype.setColor = function(color) {
      return this.color = color;
    };

    MfPolygon.prototype.setDefaults = function() {
      return this.options = {
        position: 'topleft',
        colors: {
          style: (function(_this) {
            return function(mode) {
              if (_this.mode === 'add') {
                return {
                  color: '#008000',
                  width: 3,
                  icon: {
                    iconSize: [4, 4]
                  }
                };
              }
              if (_this.mode === 'subtract') {
                return {
                  color: '#FF0000',
                  width: 3
                };
              }
            };
          })(this)
        },
        toolbars: [
          {
            rows: [
              [
                {
                  name: 'draw-polygon-add',
                  html: '<i class="drawicon-poly-green"></i>',
                  toggle: true
                }
              ]
            ]
          }
        ]
      };
    };

    MfPolygon.prototype.setStealthStyling = function() {
      return this.options = {
        position: 'topleft',
        toolbars: [
          {
            rows: []
          }
        ]
      };
    };

    MfPolygon.prototype.setAllToolOptions = function() {
      this.optionModeAll = true;
      return this.options = {
        position: 'topleft',
        colors: {
          style: (function(_this) {
            return function(mode) {
              if (_this.mode === 'add') {
                return {
                  color: '#008000',
                  width: 3,
                  icon: {
                    iconSize: [4, 4]
                  }
                };
              }
              if (_this.mode === 'subtract') {
                return {
                  color: '#FF0000',
                  width: 3
                };
              }
            };
          })(this)
        },
        toolbars: [
          {
            style: {
              width: '66px'
            },
            rows: [
              [
                {
                  name: 'draw-polygon-add',
                  html: '<i class="drawicon-poly-green"></i>',
                  toggle: true
                }, {
                  name: 'draw-polygon-sub',
                  html: '<i class="drawicon-poly-red"></i>',
                  toggle: true
                }
              ], [
                {
                  name: 'draw-rect-add',
                  html: '<i class="drawicon-rect-green"></i>',
                  toggle: true
                }, {
                  name: 'draw-rect-sub',
                  html: '<i class="drawicon-rect-red"></i>',
                  toggle: true
                }
              ], [
                {
                  name: 'draw-circle-add',
                  html: '<i class="drawicon-circle-green"></i>',
                  toggle: true
                }, {
                  name: 'draw-circle-sub',
                  html: '<i class="drawicon-circle-red"></i>',
                  toggle: true
                }
              ]
            ]
          }
        ]
      };
    };

    MfPolygon.prototype.onAdd = function(map) {
      var container;
      this.map = map;
      this.mode = null;
      this.current_tool = null;
      container = MfPolygon.__super__.onAdd.call(this, map);
      if (this.optionModeAll) {
        this.addCallback('draw-polygon-sub,draw-rect-sub,draw-circle-sub', this._subtractiveButtonPressed);
        this.addCallback('draw-polygon-add,draw-rect-add,draw-circle-add', this._additiveButtonPressed);
        this.addCallback('draw-polygon-add,draw-polygon-sub', this._drawPolygon);
        this.addCallback('draw-rect-add,draw-rect-sub', this._drawRectangle);
        this.addCallback('draw-circle-add,draw-circle-sub', this._drawCircle);
      } else {
        this.addCallback('draw-polygon-add', this._drawPolygon);
        this._drawPolygon();
      }
      this.map.on('draw:created', this.handleMarkerDrop);
      return container;
    };

    MfPolygon.prototype.handleMarkerDrop = function(e) {
      if (this.optionModeAll) {
        this.deselectAllButtons();
        this.enableBtn('draw-polygon-add');
        this.enableBtn('draw-polygon-sub');
        this.enableBtn('draw-rect-add');
        this.enableBtn('draw-rect-sub');
        this.enableBtn('draw-circle-add');
        this.enableBtn('draw-circle-sub');
      } else {
        this.enableBtn('draw-polygon-add');
        this.deselectBtn('draw-polygon-add');
      }
      return this.fire('mfpolygon:created', e);
    };

    MfPolygon.prototype._subtractiveButtonPressed = function(e, name) {
      this.mode = 'subtract';
      return this.fire('mfpolygon:subtractmode');
    };

    MfPolygon.prototype._additiveButtonPressed = function(e, name) {
      this.mode = 'add';
      return this.fire('mfpolygon:addmode');
    };

    MfPolygon.prototype.deselect = function() {
      return this.current_tool.disable();
    };

    MfPolygon.prototype.select = function() {
      this.current_tool.enable();
      return this.fire('mfpolygon:tool_selected');
    };

    MfPolygon.prototype._drawRectangle = function() {
      var ref, ref1;
      this.current_tool = new L.Draw.Rectangle(this.map, {
        shapeOptions: (ref = (ref1 = this.options.colors) != null ? typeof ref1.style === "function" ? ref1.style(this.mode) : void 0 : void 0) != null ? ref : {}
      });
      this.current_tool.options.metric = false;
      return this.current_tool.enable();
    };

    MfPolygon.prototype._drawCircle = function() {
      var ref;
      this.current_tool = new L.Draw.Circle(this.map, {
        shapeOptions: (ref = this.options.colors.style(this.mode)) != null ? ref : {}
      });
      this.current_tool.options.units = 'english';
      return this.current_tool.enable();
    };

    MfPolygon.prototype._drawPolygon = function() {
      var defaultClasses, handler, self, vertextListener;
      self = this;
      this.disableTooltipButton(this.finishButton);
      this.disableTooltipButton(this.deletePointButton);
      handler = new L.Draw.NewPoly(this.map, {
        allowIntersection: false,
        shapeOptions: {
          color: 'black',
          fillColor: this.color,
          weight: 5,
          dashArray: '5,10',
          opacity: 1,
          fillOpacity: 0.65
        }
      });
      handler.options.icon.options.iconSize.x = 16;
      handler.options.icon.options.iconSize.y = 16;
      defaultClasses = 'leaflet-marker-icon leaflet-div-icon leaflet-editing-icon leaflet-zoom-animated leaflet-clickable';
      handler.options.icon.options.className = 'leaflet-marker-icon custom-marker leaflet-editing-icon leaflet-zoom-animated leaflet-clickable';
      $('.leaflet-marker-pane').css('cursor', 'crosshair');
      handler._onTouch = function(e) {
        if (e.originalEvent.target.className.indexOf('leaflet-control-pan') > -1) {

        } else {
          return L.Draw.Polygon.prototype._onTouch.call(this, e);
        }
      };
      vertextListener = this.map.on(L.Draw.Event.DRAWVERTEX, (function(_this) {
        return function(one) {
          var ref, ref1, ref2;
          if (((ref = _this.current_tool.h) != null ? (ref1 = ref._markers) != null ? ref1.length : void 0 : void 0) > 0) {
            _this.current_tool.h.options.icon.options.iconSize.x = 8;
            _this.current_tool.h.options.icon.options.iconSize.y = 8;
            _this.current_tool.h.options.icon.options.className = defaultClasses;
            _this.enableTooltipButton(_this.deletePointButton);
            _this.fire('mfdraw:polygon-tool-active');
            if (((ref2 = _this.current_tool.h._markers) != null ? ref2.length : void 0) >= 3) {
              return _this.enableTooltipButton(_this.finishButton);
            }
          }
        };
      })(this));
      this.current_tool = {
        h: handler,
        disable: function() {
          var ref, ref1;
          this.h.disable();
          if ((ref = this.map) != null) {
            ref.off('mousedown');
          }
          if ((ref1 = this.map) != null) {
            ref1.off(L.Draw.Event.DRAWVERTEX, vertextListener);
          }
          return self.fire('mfdraw:polygon-tool-inactive');
        },
        enable: function() {
          return handler.enable();
        }
      };
      return handler.enable();
    };

    MfPolygon.prototype._polySelected = function(e) {
      var current_tool, handler, ref, ref1, ref2;
      if (!e.layer.options.poly) {
        e.layer.options.poly = {
          color: e.layer.options.color,
          drawError: {
            color: e.layer.options.color,
            timeout: 1000
          }
        };
      }
      e.layer.options.poly.allowIntersection = false;
      handler = new L.Edit.Poly(e.layer);
      handler.enable();
      this.fire('select:poly-selected');
      if ((((ref = this.current_tool) != null ? ref.h : void 0) != null) && (((ref1 = this.current_tool) != null ? (ref2 = ref1.h) != null ? ref2.disable : void 0 : void 0) != null)) {
        this.current_tool.h.disable();
      }
      current_tool = {
        h: null,
        disable: function() {
          return this.h.disable();
        },
        active: true
      };
      if (current_tool != null) {
        current_tool.h = handler;
      }
      return current_tool;
    };

    return MfPolygon;

  })(L.Control.MfButtonGrid);

}).call(this);
